import { render, staticRenderFns } from "./NewProject.vue?vue&type=template&id=436c2721"
import script from "./NewProject.vue?vue&type=script&lang=js"
export * from "./NewProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports